import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { connectSocket, SocketRoom } from 'services/socket'
import { logApiError } from 'services/apiError'
import AddCashRegisterModal from 'pages/Modals/AddCashRegisterModal'
import CashRegister from 'components/CashRegister'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { FaPlus } from 'react-icons/fa'
import { ListContainer, Row } from '../styles'

export default function CashRegisters ({
  onTabNavigate: handleTabNavigate = () => null
}) {
  const [loading, setLoading] = useState (true)
  const [cashRegisters, setCashRegisters] = useState ([])
  const [bankAccounts, setBanksAccounts] = useState ([])
  const [cardFlags, setCardFlags] = useState ([])
  const [showAddCashRegisterModal, setShowAddCashRegisterModal] = useState (false)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [])

  useEffect (() => {
    const socket = connectSocket ({
      token, rooms: [SocketRoom.business (businessId)]
    })

    socket.on (`${businessId}_cash_register_created`, handleCashRegisterCreated)
    socket.on (`${businessId}_cash_register_closed`, handleCashRegisterClosed)

    return () => {socket.disconnect ()}
    // Com [cashRegisters] o socket caia e era reconstruido a cada evento.
  }, [businessId, token])

  const getData = async () => {
    try {
      setLoading (true)

      const [{ data: cashRegisters }, { data: bankAccounts }, { data: cardFlags }] = await Promise.all ([
         cutileiApi.get (`/cash_registers?business_id=${businessId}&open=true`, requestConfig),
         cutileiApi.get (`/businesses/${businessId}/bank_accounts`, requestConfig),
         cutileiApi.get (`/card_flags`, requestConfig)
      ])

      setCashRegisters (cashRegisters)
      setBanksAccounts (bankAccounts)
      setCardFlags (cardFlags)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const handleCashRegisterCreated = cashRegister => {
    setCashRegisters (prevCashRegisters => {
      const existingIndex = prevCashRegisters.findIndex (cr => cr.id === cashRegister.id)

      if (existingIndex === -1) return [cashRegister, ...prevCashRegisters]

      const updatedCashRegisters = [...prevCashRegisters]
      updatedCashRegisters[existingIndex] = cashRegister

      return updatedCashRegisters
    })
  }

  const handleCashRegisterClosed = async cashRegister => {
    setCashRegisters (prevCashRegisters => prevCashRegisters.filter (cr => cr.id !== cashRegister.id))
    await getData ()
  }

  const toggleAddCashRegisterModal = () => setShowAddCashRegisterModal (!showAddCashRegisterModal)

  return (
    <ListContainer>
      {AuthService.hasPermission ('financial.cash_registers', 'edit') && (
        <Row>
          <SecondaryButton
            label='Abrir caixa'
            leftIcon={<FaPlus size={12} color='#FFC100' style={{marginBottom: 1}}/>}
            onClick={toggleAddCashRegisterModal}
            width={150}
            style={{marginBottom: 15}}
          />
          <AddCashRegisterModal
            visible={showAddCashRegisterModal}
            onConfirm={handleCashRegisterCreated}
            onClose={toggleAddCashRegisterModal}
          />
        </Row>
      )}
      {loading ? <Loading/> : cashRegisters.length > 0 && cashRegisters.map (cashRegister => (
        <CashRegister
          key={cashRegister.id}
          data={cashRegister}
          cardFlags={cardFlags}
          bankAccounts={bankAccounts}
          onTabNavigate={handleTabNavigate}
          onCloseCashRegister={handleCashRegisterClosed}
        />
      ))}
    </ListContainer>
  )
}
